import styled from 'styled-components'

export const Head = styled.header`
    max-height : 60px;
    width:100%;
    position : absolute;
    top:32px;
    padding-left:64px;
    padding-right:64px;
    background-color:#ffffff;
    padding-bottom:22px;
    display:flex;
    align-items:center;
    justify-content:space-between;

    @media(max-width:800px){
        flex-direction:column;
        position:relative;
        max-height:500px;
    }
`
export const Logo = styled.img`
    height:70px;
    width:201.9px;
`
export const Links = styled.div`
    ul{
        display:flex;
        margin-top:18px;
        width:100%;
        justify-content:flex-end;
        align-items:center;

        @media(max-width:600px){
            flex-direction:column;
            justify-content:center;
        }

        li{
            text-decoration:none;
            list-style-type:none;
            margin-left: 2vw;
            
            @media(max-width:600px){
                margin-left:0px;
                margin-top:10px;
            }

            a{
                text-decoration:none;
                color:#1E1D1D;
            }

            #offer-button{
            color:#ffffff;
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            border-radius:4px;
            font-size:16px;
            font-weight:bold;
            text-decoration:none;
            padding:5px;
            padding-left:20px;
            padding-right:20px;
            text-align: center;
            }

        }
    }

    
`